<div class="content-block">
  <article class="article " style="margin-top:1rem">

    <div class="title-container">
      <button class="btn btn-back" (click)="back()"><i class="fas fa-caret-left"></i> Back</button>
      <div style="flex: 10;">
        <h2 *ngIf="company != null">{{company.name}} Equipment Upload</h2>
      </div>
    </div>

  </article>

  <article class="article " style="margin-top:1rem">
    <a href="/assets/files/Master.xlsx">Download Template</a>
    <div class="row large-margin-top">
      <input type="file" name="sig" class="btn btn-primary" style="height: 75%;width:75%;" (change)="uploadFile($event)" accept=".xlsx" />
    </div>
    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-primary" (click)="upload()">Upload</button>
      </div>
    </div>
  </article>


  <app-loading-icon *ngIf="loading"></app-loading-icon>
  <!-- <article class="article " style="margin-top:0.5rem;">
    <div style="display: block;width: 100%;" *ngIf="!loading && rows.length > 0">



      <ngx-datatable  [count]="page.totalElements" [offset]="page.pageNumber" [limit]="page.size"
        [headerHeight]="50" [footerHeight]="50" (page)='setPage($event)' (sort)="onSort($event)" class="material"
        [rowClass]="getRowClass" [rows]="rows" [columnMode]="'force'" [externalPaging]="true" [externalSorting]="true"
        [rowHeight]="'auto'">

        <ngx-datatable-column name="SWL" prop="swl">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <div>{{ value }}</div>
          </ng-template>
        </ngx-datatable-column>

      </ngx-datatable>
    </div>
  </article> -->
</div>